export const PROMPT_BULK_MIN_LEN = 4;
export const PROMPT_BULK_MAX_LINES = 10;

export function countStartedPromptLines(raw) {
	return String(raw || "")
		.split(/\r?\n/)
		.filter((line) => line.trim().length > 0).length;
}

export function parsePromptLines(raw) {
	const seen = new Set();
	const lines = [];
	for (const line of String(raw || "").split(/\r?\n/)) {
		const t = line.trim();
		if (t.length === 0 || seen.has(t)) continue;
		seen.add(t);
		lines.push(t);
	}
	return lines;
}

/** First CSV field on a line, respecting double-quoted values. */
export function firstCsvField(line) {
	const s = String(line || "").trim();
	if (!s) return "";
	if (s.startsWith('"')) {
		let out = "";
		for (let i = 1; i < s.length; i += 1) {
			if (s[i] === '"' && s[i + 1] === '"') {
				out += '"';
				i += 1;
				continue;
			}
			if (s[i] === '"') break;
			out += s[i];
		}
		return out.trim();
	}
	return (s.split(",")[0] ?? "").trim();
}

/**
 * CSV → prompt texts. Accepts header "prompts" or bare first-column list. Max PROMPT_BULK_MAX_LINES.
 */
export function parseCsvPrompts(csv) {
	const rawLines = String(csv || "")
		.split(/\r?\n/)
		.map((l) => l.trim())
		.filter(Boolean);
	if (rawLines.length === 0) return { prompts: [], truncated: false };

	const header = firstCsvField(rawLines[0]).toLowerCase();
	const hasHeader = header === "prompts";
	const body = hasHeader ? rawLines.slice(1) : rawLines;

	const seen = new Set();
	const prompts = [];
	for (const row of body) {
		const t = firstCsvField(row);
		if (t.length === 0 || seen.has(t)) continue;
		seen.add(t);
		prompts.push(t);
		if (prompts.length >= PROMPT_BULK_MAX_LINES) {
			return { prompts, truncated: body.length > prompts.length };
		}
	}
	return { prompts, truncated: false };
}
